// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveContainer, Tooltip, Cell, PieChart, Pie, Legend } from 'recharts';

// Enums
import { SingleSelectQuestionDataType } from 'engagementReport/enums/propTypes';

// Utilities
import { colors } from 'common/utils/helpers';

// Components
import CustomTooltip from 'admin/engagement/reporting/components/CustomTooltip';
import CustomPieChartLabel from 'admin/engagement/reporting/components/CustomPieChart/CustomPieChartLabel';
import CustomPieChartLabelLine from 'admin/engagement/reporting/components/CustomPieChart/CustomPieChartLabelLine';

const pieLabelText = (props) => <CustomPieChartLabel {...props} width={200} fontSize={14} />;

const tooltipAttributes = [
  { tooltipLabel: 'Percentage', payloadKey: 'percentage', percentage: true },
  { tooltipLabel: 'Count', payloadKey: 'count' },
];

const SingleSelectPieChart = ({ data }) => {
  const chartData = data.filter((entry) => entry.percentage > 0);
  const emptyData = data.filter((entry) => entry.percentage === 0);
  const legendPayload = chartData
    .map(({ label }, index) => ({
      type: 'square',
      value: label,
      color: colors[index % colors.length],
    }))
    .concat(
      emptyData.map(({ label }) => ({
        type: 'square',
        value: label,
        color: '#cccccc',
      }))
    );

  return (
    <>
      <ResponsiveContainer width="100%" aspect={16 / 9}>
        {/* eslint-disable react/no-array-index-key, react/prop-types */}
        <PieChart>
          <Tooltip
            content={<CustomTooltip attributes={tooltipAttributes} />}
            isAnimationActive={false}
          />
          <Pie
            data={chartData}
            dataKey="percentage"
            animationDuration={800}
            labelLine={CustomPieChartLabelLine}
            label={pieLabelText}
          >
            {chartData.map((entry, index) => (
              <Cell key={index} fill={colors[index % colors.length]} />
            ))}
          </Pie>
        </PieChart>
        {/* eslint-enable react/no-array-index-key, react/prop-types */}
      </ResponsiveContainer>
      <Legend
        layout="vertical"
        width="100%"
        wrapperStyle={{ marginTop: '20px', position: 'static' }}
        payload={legendPayload}
      />
    </>
  );
};

Legend.propTypes = {
  width: PropTypes.string.isRequired,
};

SingleSelectPieChart.propTypes = {
  data: SingleSelectQuestionDataType.isRequired,
};

export default SingleSelectPieChart;
